import { render, staticRenderFns } from "./Cate.vue?vue&type=template&id=c7ddc0f4&scoped=true&"
import script from "./Cate.vue?vue&type=script&lang=js&"
export * from "./Cate.vue?vue&type=script&lang=js&"
import style0 from "./Cate.vue?vue&type=style&index=0&id=c7ddc0f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ddc0f4",
  null
  
)

export default component.exports